// extracted by mini-css-extract-plugin
export default {"RichTextBody":"RichTextBody-styles__RichTextBody___6jl4"};